import { render, staticRenderFns } from "./PayinAffiliatedMerchants.vue?vue&type=template&id=2816f849&"
import script from "./PayinAffiliatedMerchants.vue?vue&type=script&lang=js&"
export * from "./PayinAffiliatedMerchants.vue?vue&type=script&lang=js&"
import style0 from "./PayinAffiliatedMerchants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports